import { render, staticRenderFns } from "./quickIntegrationAddWidget.vue?vue&type=template&id=159610e1"
import script from "./quickIntegrationAddWidget.vue?vue&type=script&lang=js"
export * from "./quickIntegrationAddWidget.vue?vue&type=script&lang=js"
import style0 from "./quickIntegrationAddWidget.vue?vue&type=style&index=0&id=159610e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports